import { render } from "./scrollSnippet.vue?vue&type=template&id=c247ecea&scoped=true"
import script from "./scrollSnippet.vue?vue&type=script&lang=js"
export * from "./scrollSnippet.vue?vue&type=script&lang=js"

import "./scrollSnippet.vue?vue&type=style&index=0&id=c247ecea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c247ecea"]])

export default __exports__